import Authentication from "../components/Layout/Authentication/Authentication";

const AuthPage = () => {
  return <Authentication />;
};

export default AuthPage;
